<template>
  <div
    class="vm-dir"
    :class="[browser_size, status == 'edit' ? 'status-edit' : '', status == 'sort' ? 'nocopy' : '', drag ? 'drag': '']"
    v-infinite-scroll="load_more"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="200"
  >
  <!-- v-infinite-scroll="load_more"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="200"  -->
    <draggable v-model="pre_post_list" :disabled="status != 'sort'" ghostClass="ghost" chosen-class="chosen" :options="options" force-fallback="true" @start="start" @end="end">
      <div class="item" @click="pick(item.post_id)" v-for="(item, i) in pre_post_list" :key="i">
        <!-- <div class="flex-box flex-a-center"> -->
          <div class="tit text-overflow-1 flex-item-1">{{item.title ? item.title : $t('c.Dir.text1')}}</div>
          <!-- <tag v-if="item.self_only == 1" class="circle gray mb16 pt4 pb4 pr8 pl8">
            {{item.status == 3 ? '草稿 - ' : ''}}仅自己可见
          </tag> -->
        <!-- </div> -->
        <div class="date black-3 fs12">
          <span v-if="item.status == 3" class="mr4">{{$t('c.Dir.text2')}}</span>
          <span v-if="item.status == 4" class="mr4">{{$t('c.Dir.text3')}}</span>
          <span v-text="$time_show(item.publish_time)"></span>
          <span class="cyan" v-if="is_show_unlock && item.min_price > 0">
            <i class="afd fs12 ml8" :class="[item.is_public == 1 ? 'afd-unlock' : 'afd-lock']"></i>
            ¥{{item.min_price}}<span v-if="!item.permanent && !item.buyPlan && album_id != 'eaf429d4c05511ec818652540025c377' && album_id != 'c0f9a2c442ca11edbf4152540025c377'">{{$t('c.Dir.text4')}}</span>
            <span v-if="!item.is_public" class="ml8">{{$t('c.Dir.text5')}}</span>
          </span>
        </div>
        <div v-if="item.has_video" class="video-box mt8">
          <pic :src="item.video_thumb" width="88" height="48" />
          <i class="afd afd-play self-center"></i>
        </div>
        <div v-if="item.has_audio" class="audio-box mt8">
          <pic :src="item.audio_thumb ? item.audio_thumb : audio_cover" width="48" height="48" />
          <i v-if="item.audio_thumb" class="afd afd-audio-sign self-center"></i>
        </div>
        <div v-if="item.pics && item.pics.length > 0" class="img-box flex-box mt8">
          <template v-for="(img, k) in item.pics">
            <div class="inner-img-box" v-if="k <= 5" :key="k">
              <pic :src="img" width="40" height="40" />
            </div>
          </template>
          <div
            v-if="item.pics.length >= 6"
            class="inner-img-box flex-box flex-center fs12"
          >+{{item.pics.length}}</div>
        </div>

        <div
          v-if="status == 'edit'"
          :class="{on : post_ids_map[item.post_id]}"
          class="check-box fs12"
        >{{post_ids_map[item.post_id]}}</div>
        <!-- is_reverse -->
        <div v-if="status != 'edit'" class="check-box fs12 on2">{{is_reverse ? pre_post_list.length - i : (i + 1) }}</div>
      </div>
    </draggable>
    <!--
    //mock  data
    <div class="item on">
      <div class="tit text-overflow-1">前言</div>
      <div class="date black-3 fs12">2018-09-01</div>
      <div class="check-box fs12"></div>
    </div>
    <div class="item">
      <div class="tit text-overflow-1">第二章 前印象派：走向真实，1820—1870</div>
      <div class="date black-3 fs12">
        2018-09-01
        <span class="cyan">
          <i class="afd afd-lock fs12 ml8"></i> ¥5.00元/月
        </span>
      </div>
      <div class="check-box on fs12">1</div>
    </div>
    <div class="item">
      <div class="tit text-overflow-1">第二章 前印象派：走向真实，1820—1870</div>
      <div class="date black-3 fs12">2018-09-01</div>
      <div class="video-box mt8">
        <i class="afd afd-play self-center"></i>
      </div>
      <div class="check-box on2 fs12">2</div>
    </div>

    <div class="item">
      <div class="tit text-overflow-1">第二章 前印象派：走向真实，1820—1870</div>
      <div class="date black-3 fs12">2018-09-01</div>
      <div class="img-box flex-box mt8">
        <div class="inner-img-box"></div>
        <div class="inner-img-box flex-box flex-center fs12">+9</div>
      </div>
    </div>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
import draggable from 'vuedraggable'; //https://github.com/SortableJS/Vue.Draggable   中文：http://www.itxst.com/vue-draggable/tutorial.html

export default {
  name: "dir",
  model: {
    prop: "post_ids",
    event: "change"
  },
  props: {
    post_list: {
      type: Array,
      default: []
    },
    post_ids: {
      type: Array,
      default: []
    },
    status: {
      type: String,
      default: ""
    },
    album_id: {
      type: String,
      default: ""
    },
    is_reverse: {
      default: false
    },
    is_show_unlock:{
      default: true
    }
  },
  watch:{
    post_list(){
      this.pre_post_list = this.hard_code(this.post_list)
    }
  },
  data() {
    return {
      pre_post_list: this.hard_code(this.post_list),
      drag:false,
      busy: false,
      audio_cover: `${this.GL.PIC_HOST}/static/img/audio-cover-default@2x.png`
    };
  },
  computed: {
    ...mapState("app", ["browser_size"]),
    options(){
      return {
        animation: 200,
        delay:this.browser_size == 'small' ? 600 : 0,
      }
    },
    post_ids_map() {
      let o = {};
      this.post_ids.forEach((v, k) => {
        o[v] = k + 1;
      });
      return o;
    },
  },
  components: {
    draggable,
  },
  mounted() {},
  methods: {
    hard_code(list){
      if(this.album_id == 'eaf429d4c05511ec818652540025c377' || this.album_id == 'c0f9a2c442ca11edbf4152540025c377'){ //sb用户的需求，只要显示第一个图片
        let is_first_img = -1;
        for(var i = 0; i < list.length; i++){
          if(is_first_img != -1){
            list[i].video_thumb = ''
            list[i].audio_thumb = ''
            list[i].has_video = 0
            list[i].has_audio = 0
            list[i].pics = []
            continue;
          }
          if(is_first_img == -1 && (list[i].video_thumb || list[i].audio_thumb || list[i].pics.length > 0)){
            is_first_img = i
          }
        }
      }
      if(this.album_id == '3bf30386915811ed89d052540025c377' || this.album_id == '9b2388fce0c811ed89f752540025c377' || this.album_id == 'f3e5934ae63111ed95bb52540025c377'){ //不显示图
        for(var i = 0; i < list.length; i++){
          list[i].video_thumb = ''
          list[i].audio_thumb = ''
          list[i].has_video = 0
          list[i].has_audio = 0
          list[i].pics = [];
        }
      }
      return list;
    },
    start(){
        this.drag = true;
    },
    end(){
        this.drag = false;
        // let new_post_ids = this.pre_post_list.map(v => v.post_id).reverse();
        // console.log(new_post_ids)
        this.$emit("change", this.pre_post_list.map(v => v.post_id));
    },
    pick(post_id) {
      if (this.status == "") {
        this.$emit("close");
        this.$router.push(`/album/${this.album_id}/${post_id}`);
        // this.$mixin_router_push(`/album/${this.album_id}/${post_id}`);
        return false;
      }
      if (this.post_ids_map[post_id]) {
        let i = this.post_ids.findIndex(v => v == post_id);
        this.post_ids.splice(i, 1);
      } else {
        this.post_ids.push(post_id);
      }
      this.$emit("change", this.post_ids);
    },
    load_more() {
      this.$emit("load_more");
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-dir {
  .item {
    padding: 8px 44px;
    position: relative;
    box-sizing :border-box;

    &.on {
      background: #F2F2F2;
    }
  }


  .item:hover {
    background: #F2F2F2;
    cursor: pointer;
  }

  // }
  .audio-box, .video-box {
    width: 88px;
    height: 48px;
    background: $black-1;
    border-radius: 5px;
    color: $white;
    position: relative;
  }

  .audio-box {
    width: 48px;
  }

  .inner-img-box {
    width: 40px;
    height: 40px;
    background: $black-1;
    border-radius: 5px;
    margin-right: 4px;

    &:last-child {
      margin-right: 0px;
    }

    img {
      border-radius: 5px;
    }
  }

  .check-box {
    position: absolute;
    border: 1px solid $black-3;
    border-radius: 100px;
    width: 13px;
    height: 13px;
    left: 12px;
    top: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $white;

    &.on {
      background: $blue-2;
      border: 0;
    }

    &.on2 {
      background: transparent;
      border: 0;
      color: $black-3;
    }
  }
  .chosen{
    background:$white !important;
    box-shadow:$layer-shadow !important;
  }
  .ghost{
    background:#F2F2F2 !important;
  }
  &.small,
  &.drag{
    .item:hover {
      background: none;
    }
  }
  &.small{
    .chosen{
      // border:1px solid $black-1;
    }
  }

}
</style>
